/**
 * Send branded notification emails via the Netlify function.
 * Fire-and-forget — never blocks the UI.
 */

type NotificationType =
  | 'deposit_received'
  | 'deposit_confirmed'
  | 'withdrawal_requested'
  | 'withdrawal_approved'
  | 'withdrawal_rejected'
  | 'investment_activated'
  | 'investment_matured'
  | 'kyc_approved'
  | 'kyc_rejected'
  | 'password_changed';

export function sendNotificationEmail(
  type: NotificationType,
  email: string,
  data?: Record<string, any>,
) {
  fetch('/.netlify/functions/send-notification-email', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ type, email, data }),
  }).catch(() => {});
}
